export enum PayoutTransactionOnlineTransferEnum {
    None = 0,
    Pending = 1,
    Completed = 2,
    Cancelled = 3
}
